import request from '@/config/axios'

/** O2O 预约 — 阶段 2 对接 /admin-api/o2o/reservation/* */
export const O2oReservationApi = {
  getPage: async (params: any) => {
    return await request.get({ url: '/o2o/reservation/page', params })
  },
  get: async (id: number) => {
    return await request.get({ url: '/o2o/reservation/get?id=' + id })
  },
  reschedule: async (data: any) => {
    return await request.put({ url: '/o2o/reservation/reschedule', data })
  },
  cancel: async (data: any) => {
    return await request.put({ url: '/o2o/reservation/cancel', data })
  }
}
